var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-btn",
        {
          directives: [
            {
              name: "touch-hold",
              rawName: "v-touch-hold:400",
              value: _vm.onHold,
              expression: "onHold",
              arg: "400"
            }
          ],
          staticClass: "q-btn-dropdown q-btn-dropdown-simple",
          attrs: {
            id: "thebtn",
            loading: _vm.loading,
            disable: _vm.disable,
            noCaps: _vm.noCaps,
            noWrap: _vm.noWrap,
            label: _vm.label,
            outline: _vm.outline,
            flat: _vm.flat,
            round: _vm.round,
            push: _vm.push,
            size: _vm.size,
            color: _vm.color,
            textColor: _vm.textColor,
            glossy: _vm.glossy,
            dense: _vm.dense,
            noRipple: _vm.noRipple
          },
          on: { click: _vm.onClick }
        },
        [
          _c("q-icon", { attrs: { name: _vm.icon, size: "20px" } }),
          _vm._v(" "),
          !_vm.showing ? _c("span", [_vm._v("…")]) : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "q-popover",
            {
              ref: "popover",
              class: _vm.contentClass,
              style: _vm.contentStyle,
              attrs: {
                disable: _vm.disable,
                anchor: "bottom right",
                self: "top right",
                fit: ""
              },
              model: {
                value: _vm.showing,
                callback: function($$v) {
                  _vm.showing = $$v
                },
                expression: "showing"
              }
            },
            [_vm._t("default")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac641100", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac641100","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/btn-hold.vue
// module id = null
// module chunks = 